function* iterateSlideActionContainers(slide) {
    const { animation } = slide;
    for (const objectUuid in animation) {
        yield animation[objectUuid];
    }
}

function* iterateTourActionContainers(data) {
    if (data.assets) {
        const { audio } = data.assets;
        for (const audioUuid in audio) {
            yield audio[audioUuid];
        }
    }

    if (data.layers) {
        const { layers2D } = data.layers;
        for (const layerUuid in layers2D) {
            const { objects } = layers2D[layerUuid];

            for (const objectUuid in objects) {
                yield objects[objectUuid];
            }
        }
    }

    if (data.slides) {
        for (const slideData of data.slides) {
            const { slideQuiz } = slideData;

            if (slideQuiz) {
                yield { action: slideQuiz.actions };
            }
        }
    }
}

function* iterateActions(actionContainers) {
    for (const a of actionContainers) {
        if (a && a.action && a.action.length) {
            for (const ac of a.action) {
                if (ac) {
                    yield ac;
                }
            }
        }
    }
}

module.exports = {
    iterateSlideActionContainers,
    iterateTourActionContainers,
    iterateActions,
};
